<template>
  <div class="project-page">
    <a-card>
      <div class="project-layout">
        <!-- 右侧内容区 -->
        <div class="main-content">
          <div class="project-title">项目管理</div>
          <div class="project-search-bar">
            <a-form layout="inline">
              <a-form-item label="项目名称">
                <a-input placeholder="请输入项目名称" style="width:180px;" />
              </a-form-item>
              <a-form-item label="项目ID">
                <a-input placeholder="请输入项目ID" style="width:180px;" />
              </a-form-item>
              <a-form-item>
                <a-button type="primary" style="margin-right:8px;">
                  <template #icon><search-outlined /></template>
                  查询
                </a-button>
                <a-button>
                  <template #icon><reload-outlined /></template>
                  重置
                </a-button>
              </a-form-item>
            </a-form>
          </div>
          <div class="project-table-bar" style="text-align:right;margin-bottom:8px;">
            <a-button type="primary">+ 新增</a-button>
          </div>
          <a-table :columns="columns" :data-source="dataSource" :pagination="false" size="middle">
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'action'">
                <a-button type="link" size="small" style="margin-right:8px;">编辑</a-button>
                <a-button type="link" size="small" style="margin-right:8px;color:#ff4d4f;">删除</a-button>
              </template>
            </template>
          </a-table>
          <div class="project-pagination">
            <span>共1条</span>
            <a-pagination :total="1" :pageSize="10" :current="1" style="margin: 0 16px;" />
            <a-select :value="10" style="width: 90px;">
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
            </a-select>
          </div>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import SystemSideMenu from '@/components/SystemSideMenu.vue'
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons-vue'

const selectedKeys = ref(['project'])
const openKeys = ref(['system'])
const router = useRouter()
const route = useRoute()

// 页面加载和路由变化时自动高亮
watch(
  () => route.path,
  (path) => {
    if (path === '/system/project') selectedKeys.value = ['project']
    else if (path === '/system/systemConfig/user-mgr') selectedKeys.value = ['user-mgr']
    else if (path === '/system/systemConfig/feedback') selectedKeys.value = ['feedback']
    else if (path === '/system/systemConfig/sync') selectedKeys.value = ['sync']
    else selectedKeys.value = []
    openKeys.value = ['system']
  },
  { immediate: true }
)

function onMenuSelect({ key }: { key: string }) {
  selectedKeys.value = [key]
  if (key === 'user-mgr') router.push('/system/systemConfig/user-mgr')
  else if (key === 'feedback') router.push('/system/systemConfig/feedback')
  else if (key === 'sync') router.push('/system/systemConfig/sync')
  else if (key === 'project') router.push('/system/systemConfig/project')
  // 其它菜单可按需跳转
}

const columns = [
  { title: '项目ID', dataIndex: 'id', key: 'id' },
  { title: '项目名称', dataIndex: 'name', key: 'name' },
  { title: '管理员', dataIndex: 'admin', key: 'admin' },
  { title: '是否启用', dataIndex: 'enabled', key: 'enabled' },
  { title: '区域数', dataIndex: 'areaCount', key: 'areaCount' },
  { title: '设备数', dataIndex: 'deviceCount', key: 'deviceCount' },
  { title: '操作', key: 'action' }
]

const dataSource = [
  {
    id: '17868387179804222144',
    name: '默认项目',
    admin: 'administrator',
    enabled: '是',
    areaCount: 0,
    deviceCount: 0
  }
]
</script>

<style lang="less" scoped>
.project-page {
  padding: 24px;
  background: #f5f7f9;
  min-height: 100vh;
  .project-layout {
    display: flex;
    .side-menu {
      width: 220px;
      background: #f8fafb;
      border-radius: 4px;
      margin-right: 16px;
      padding: 16px 0;
      min-height: 600px;
    }
    .main-content {
      flex: 1;
      background: #fff;
      border-radius: 4px;
      padding: 24px;
      .project-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 12px;
      }
      .project-search-bar {
        margin-bottom: 12px;
        background: #fafbfc;
        padding: 16px 16px 0 16px;
        border-radius: 4px;
      }
      .project-pagination {
        display: flex;
        align-items: center;
        margin-top: 12px;
      }
    }
  }
}
</style>